import { jsx, Fragment } from 'react/jsx-runtime';
import { styled, Typography } from '@mui/material';

function Header({ header, divider = false, typographyProps = {}, sx = {} }) {
    if (!header) {
        return null;
    }
    return (jsx(StyledHeader, { "$divider": divider, sx: sx, children: typeof header === "string" ? (jsx(Typography, Object.assign({ variant: "h6" }, typographyProps, { children: header }))) : (jsx(Fragment, { children: header })) }));
}
const StyledHeader = styled("div")(({ theme, $divider }) => (Object.assign({ padding: theme.spacing(1.5, 2.5, 0), marginBottom: theme.spacing(1.5), color: theme.palette.text.high }, ($divider && {
    borderBottom: `1px solid ${theme.palette.ui50}`,
}))));

export { Header };
//# sourceMappingURL=Header.js.map
